<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    opacity="0.2"
    d="M4 11.5714L11.0015 4L10.9985 9.42857H16L8.99853 17V11.5714H4Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.3663 3.06891C11.7496 3.21909 12.0017 3.58885 12.0015 4.00053L11.9991 8.42857H16C16.3974 8.42857 16.757 8.66383 16.9162 9.0279C17.0754 9.39197 17.004 9.81576 16.7342 10.1075L9.73273 17.6789C9.45329 17.9811 9.01724 18.0812 8.63398 17.9312C8.25071 17.7811 7.99853 17.4116 7.99853 17V12.5714H4C3.60264 12.5714 3.24298 12.3362 3.08378 11.9721C2.92457 11.608 2.99602 11.1842 3.2658 10.8925L10.2673 3.32106C10.5468 3.0188 10.983 2.91872 11.3663 3.06891ZM6.28675 10.5714H8.99853C9.55082 10.5714 9.99853 11.0191 9.99853 11.5714V14.4457L13.7133 10.4286H10.9985C10.7332 10.4286 10.4788 10.3231 10.2912 10.1355C10.1037 9.94783 9.99839 9.69333 9.99853 9.42802L10.0001 6.5558L6.28675 10.5714Z"
    fill="currentColor"
  />
</svg>
